import { CheckCircle2, XCircle, CircleDashed, MinusCircle, Workflow } from 'lucide-react';
import { EmptyState } from '../ui/EmptyState';
import { formatRelativeTime } from '../../utils/format';
import type { GitHubWorkflowRun } from '../../types';

function RunIcon({ run }: { run: GitHubWorkflowRun }) {
  if (run.status !== 'completed') {
    return <CircleDashed size={16} className="shrink-0 animate-spin text-amber-500" />;
  }
  if (run.conclusion === 'success') return <CheckCircle2 size={16} className="shrink-0 text-pulse-500" />;
  if (run.conclusion === 'failure') return <XCircle size={16} className="shrink-0 text-rose-500" />;
  return <MinusCircle size={16} className="shrink-0 text-slate-400" />;
}

export function WorkflowRunList({ runs }: { runs: GitHubWorkflowRun[] }) {
  if (runs.length === 0) {
    return <EmptyState icon={Workflow} title="No recent workflow runs" />;
  }

  return (
    <ul className="divide-y divide-slate-100 dark:divide-slate-800">
      {runs.map((run) => (
        <li key={run.id} className="flex items-center gap-3 py-3">
          <RunIcon run={run} />
          <div className="min-w-0 flex-1">
            <a
              href={run.htmlUrl}
              target="_blank"
              rel="noreferrer"
              className="block truncate text-sm font-medium text-slate-800 hover:text-pulse-600 dark:text-slate-200 dark:hover:text-pulse-400"
            >
              {run.repo} &middot; {run.name}
            </a>
            <p className="mt-0.5 text-xs text-slate-400">
              {run.headBranch} &middot; {formatRelativeTime(run.updatedAt)}
            </p>
          </div>
        </li>
      ))}
    </ul>
  );
}
